<template>
  <div>
    <el-tabs type="border-card"
             v-model="activeTab" @tab-click="handleTabChange">
      <el-tab-pane label="标准授权"
                   name="standard" :disabled="disabledBasics">
        <div v-if="!payInfoLoaded"
             v-loading="true"
             class="pay-loading"></div>
        <BuyTab v-if="payInfoLoaded && activeTab === 'standard'"
                @payTypeChange="payTypeChange"
                @balancePay="handleBalancePay"
                :outTradeno="standardOutTradeno"
                :title="standardTitle"
                :price="standardPrice"
                :qrcodeUrl='qrcodeUrl'
                :couponPrice="couponPrice"
                :realPrice="price"
                :memberLvDiscount="memberLvDiscount"
                :memBalance="memBalance"
                :defaultPayType="defaultPayType"
                :balancePaying="balancePaying"
                :desc="priceDesc"
        />
      </el-tab-pane>
      <el-tab-pane label="高级授权"
                   name="advanced">
        <div v-if="!payInfoLoaded"
             v-loading="true"
             class="pay-loading"></div>
        <BuyTab v-if="payInfoLoaded && activeTab === 'advanced'"
                @payTypeChange="payTypeChange"
                @balancePay="handleBalancePay"
                :outTradeno="advancedOutTradeno"
                :title="advancedTitle"
                :price="advancedPrice"
                :qrcodeUrl='qrcodeUrl'
                :couponPrice="couponPrice"
                :realPrice="price"
                :memberLvDiscount="memberLvDiscount"
                :memBalance="memBalance"
                :defaultPayType="defaultPayType"
                :balancePaying="balancePaying"
                :desc="price2Desc"
        />
      </el-tab-pane>
    </el-tabs>
    <el-row :gutter="10" style="margin-top:10px;" v-if="couponOpen">
      <el-col :span="4">
        <span class="coupon-label">优惠券：</span>
      </el-col>
      <el-col :span="16">
        <el-input v-model="coupon" placeholder="请输入优惠券编码"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button @click="setCoupon"
                   type="primary">确认</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="10" style="margin-top:10px;">
      <el-col :span="14"><span class="hint"><i class="el-icon-warning"></i> {{ payHint }}</span></el-col>
      <el-col :span="5">
        <el-button v-if="activePayType !== 'balance'"
                   @click="confirmPay"
                   type="success">我已支付</el-button>
      </el-col>
      <el-col :span="5">
        <el-button @click="exit">取 消</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import BuyTab from './BuyTab'

// eslint-disable-next-line no-unused-vars
import { getWxPayQrcode, queryOrderStatus, queryOrderStatusAli, changeOrderStatus, changeOrderStatusAli, getAliPayQrcode, calcPayPrice, balancePay } from '@/api/pay'
let timeOut = null
let mockTimer = null // 【临时-测试用】模拟支付自动确认定时器
export default {
  name: 'Buy',
  components: { BuyTab },
  props: {
    pluginId: {
      type: Number,
      required: true
    },
    standardTitle: {
      type: String,
      required: true,
      default: ''
    },
    standardPrice: {
      type: Number,
      required: true,
      default: 0
    },
    advancedTitle: {
      type: String,
      required: true,
      default: ''
    },
    advancedPrice: {
      type: Number,
      required: true,
      default: 0
    },
    disabledBasics: {
      type: Boolean,
      default: false
    },
    activeTabIndex: {
      type: String,
      default: 'standard'
    },
    isUpdate: {
      type: Number,
      default: 0
    },
    couponOpen: {
      type: Boolean,
      default: false
    },
    priceDesc: {
      type: String,
      default: '一年免费更新升级，仅支持自营项目使用，禁止用于外包'
    },
    price2Desc: {
      type: String,
      default: '长期免费更新升级，支持自营项目、外包项目使用'
    }
  },
  data () {
    return {
      activeTab: '', // standard - 标准授权、 advanced - 高级授权
      activePayType: '', // 三种支付方式, 分别为:wechatPay、aliPay、balance
      qrcodeUrl: '', // 二维码
      standardOutTradeno: '', // 标准版订单编号
      advancedOutTradeno: '', // 高级版订单编号
      coupon: '', // 优惠券编码
      couponPrice: '', // 优惠金额
      price: '', // 实际支付费用
      memberLvDiscount: 0, // 会员等级折扣
      mockPay: false, // 【临时-测试用】后端开启模拟支付，无需扫码，自动完成支付
      memBalance: '0.00', // 账户消费余额（元）
      defaultPayType: 'wechatPay', // 默认支付方式（余额充足时优先余额支付）
      balanceOutTradeno: '', // 余额支付预订单号
      balancePaying: false, // 余额支付中（防重复提交）
      payInfoLoaded: false, // 算价完成后才渲染支付面板，保证默认支付方式准确
      loadedTab: '' // 已算价的授权类型，避免重复算价
    }
  },
  computed: {
    // 底部提示文案
    payHint () {
      if (this.activePayType === 'balance') {
        return '余额支付将直接扣减账户消费余额，支付成功后立即开通授权'
      }
      return this.mockPay ? '模拟支付模式：正在自动完成购买，无需扫码支付' : '如已成功支付但较长时间没有跳转请点击"我已支付"'
    }
  },
  methods: {
    // 切换授权类型：价格不同需重新算价，并重新决定默认支付方式
    handleTabChange (tab) {
      // 点击当前已激活的授权类型不重复算价，避免重置用户手动选择的支付方式
      if (tab && tab.name === this.loadedTab) {
        return false
      }
      this.payInfoLoaded = false
      this.qrcodeUrl = ''
      this.standardOutTradeno = ''
      this.advancedOutTradeno = ''
      this.couponPrice = ''
      this.price = ''
      this.loadPayPrice()
    },
    // 购买前算价：返回实际支付金额、账户消费余额与预订单号；余额充足时优先选中余额支付
    // keepOutTradeno 为 true 时复用原订单号（支付失败重试），避免"请求超时但已扣款"场景重复扣款
    loadPayPrice (keepOutTradeno) {
      return calcPayPrice({
        pluginId: this.pluginId,
        priceLevel: this.activeTab === 'advanced' ? 2 : 1,
        coupon: this.coupon,
        isUpdate: this.isUpdate,
        outTradeno: keepOutTradeno ? this.balanceOutTradeno : ''
      }).then(res => {
        const { code, data, msg } = res
        if (code !== 0) {
          this.$message.error(msg)
          return false
        }
        const { price, couponPrice, memberLvDiscount, memBalance, outTradeno } = data
        this.price = price
        this.couponPrice = couponPrice
        this.memberLvDiscount = memberLvDiscount
        this.memBalance = memBalance
        this.balanceOutTradeno = outTradeno
        this.defaultPayType = Number(memBalance) >= Number(price) ? 'balance' : 'wechatPay'
        this.loadedTab = this.activeTab
        this.payInfoLoaded = true
      })
    },
    // 余额支付：同步扣款，成功后直接完成购买
    handleBalancePay () {
      if (this.activePayType !== 'balance' || this.balancePaying) {
        return false
      }
      if (this.balanceOutTradeno === '') {
        this.$message.error('订单信息已过期，请刷新后重试')
        return false
      }
      this.balancePaying = true
      balancePay({
        pluginId: this.pluginId,
        priceLevel: this.activeTab === 'advanced' ? 2 : 1,
        outTradeno: this.balanceOutTradeno,
        coupon: this.coupon,
        isUpdate: this.isUpdate
      }).then(res => {
        this.balancePaying = false
        const { code, data, msg } = res
        if (code !== 0) {
          this.$message.error(msg)
          // 余额不足等失败场景：重新算价刷新账户余额，且复用原订单号保证重试幂等
          this.loadPayPrice(true)
          return false
        }
        this.$message.success((data && data.msg) || '支付成功')
        this.$emit('confirmPay', { type: 'balance', status: 'SUCCESS' })
        this.die()
      }).catch(() => {
        this.balancePaying = false
      })
    },
    payTypeChange (val) {
      this.activePayType = val
      // 余额支付无需生成支付二维码，直接展示余额支付面板
      if (val === 'balance') {
        this.qrcodeUrl = ''
        // 刷新实时账户余额与应付金额（优惠券可能已变更）
        this.loadPayPrice()
        return false
      }
      this.pay(this.activeTab, this.activePayType)
    },
    // 请求二维码
    pay (activeTab, activePayType) {
      // console.log(activeTab, activePayType)
      // 余额支付：仅重新算价（优惠券变更后刷新应付金额与余额），不生成二维码
      if (activePayType === 'balance') {
        this.loadPayPrice()
        return false
      }
      // 获取微信二维码
      if (activeTab === 'standard' && activePayType === 'wechatPay') {
        getWxPayQrcode({
          pluginId: this.pluginId,
          priceLevel: 1,
          outTradeno: this.standardOutTradeno,
          coupon: this.coupon
        }).then(res => {
          const { code, data, msg } = res
          if (code !== 0) {
            this.$message.error(msg)
            return false
          }
          const { codeUrl, outTradeno, couponPrice, price, memberLvDiscount, mockPay } = data
          this.qrcodeUrl = codeUrl
          this.standardOutTradeno = outTradeno
          this.couponPrice = couponPrice
          this.price = price
          this.memberLvDiscount = memberLvDiscount
          this.handleMockPay(mockPay)
        })
      } else if (activeTab === 'advanced' && activePayType === 'wechatPay') {
        getWxPayQrcode({
          pluginId: this.pluginId,
          isUpdate: this.isUpdate,
          priceLevel: 2,
          outTradeno: this.advancedOutTradeno,
          coupon: this.coupon
        }).then(res => {
          const { code, data, msg } = res
          if (code !== 0) {
            this.$message.error(msg)
            return false
          }
          const { codeUrl, outTradeno, couponPrice, price, memberLvDiscount, mockPay } = data
          this.qrcodeUrl = codeUrl
          this.advancedOutTradeno = outTradeno
          this.couponPrice = couponPrice
          this.price = price
          this.memberLvDiscount = memberLvDiscount
          this.handleMockPay(mockPay)
        })
        // 获取支付宝二维码
      } else if (activeTab === 'standard' && activePayType === 'aliPay') {
        getAliPayQrcode({
          pluginId: this.pluginId,
          priceLevel: 1,
          outTradeno: this.standardOutTradeno,
          coupon: this.coupon
        }).then(res => {
          const { code, data, msg } = res
          if (code !== 0) {
            this.$message.error(msg)
            return false
          }
          const { codeUrl, outTradeno, couponPrice, price, memberLvDiscount, mockPay } = data
          this.qrcodeUrl = codeUrl
          this.standardOutTradeno = outTradeno
          this.couponPrice = couponPrice
          this.price = price
          this.memberLvDiscount = memberLvDiscount
          this.handleMockPay(mockPay)
        })
      } else if (activeTab === 'advanced' && activePayType === 'aliPay') {
        getAliPayQrcode({
          pluginId: this.pluginId,
          isUpdate: this.isUpdate,
          priceLevel: 2,
          outTradeno: this.advancedOutTradeno,
          coupon: this.coupon
        }).then(res => {
          const { code, data, msg } = res
          if (code !== 0) {
            this.$message.error(msg)
            return false
          }
          const { codeUrl, outTradeno, couponPrice, price, memberLvDiscount, mockPay } = data
          this.qrcodeUrl = codeUrl
          this.advancedOutTradeno = outTradeno
          this.couponPrice = couponPrice
          this.price = price
          this.memberLvDiscount = memberLvDiscount
          this.handleMockPay(mockPay)
        })
      }
    },
    // 【临时-测试用】后端开启模拟支付时，无需扫码，订单生成后自动确认支付完成购买
    handleMockPay (mockPay) {
      this.mockPay = !!mockPay
      if (this.mockPay) {
        mockTimer = setTimeout(() => {
          this.confirmPay()
        }, 300)
      }
    },
    setCoupon () {
      if (!this.coupon) {
        this.$message.error('优惠券不能为空!')
      }
      this.pay(this.activeTab, this.activePayType)
    },
    // 用户确认已经支付
    confirmPay () {
      const promises = []
      // 按当前选择的支付方式确认，避免两种支付方式重复处理同一订单
      const changeStatus = this.activePayType === 'aliPay' ? changeOrderStatusAli : changeOrderStatus
      if (this.standardOutTradeno !== '') {
        promises.push(changeStatus({
          outTradeNo: this.standardOutTradeno
        }))
      }
      if (this.advancedOutTradeno !== '') {
        promises.push(changeStatus({
          outTradeNo: this.advancedOutTradeno
        }))
      }
      if (promises.length > 0) {
        Promise.all(promises).then(res => {
          // console.log(res)
          for (let i = 0; i < res.length; i++) {
            const { code, data } = res[i]
            if (code !== 0) {
              continue
            }
            const { type, status } = data
            if ((type === 'wechatPay' && status === 'SUCCESS') || (type === 'aliPay' && status === 'TRADE_SUCCESS')) {
              this.$emit('confirmPay', data)
              this.die()
              return true
            }
          }
          this.$message.error('您尚未支付!')
        })
      }
    },
    // 轮询检查是否已经支付
    checkPay () {
      timeOut && clearInterval(timeOut)
      timeOut = setInterval(() => {
        const promises = []
        if (this.standardOutTradeno !== '') {
          promises.push(queryOrderStatus({
            outTradeNo: this.standardOutTradeno
          }), queryOrderStatusAli({
            outTradeNo: this.standardOutTradeno
          }))
        }
        if (this.advancedOutTradeno !== '') {
          promises.push(queryOrderStatus({
            outTradeNo: this.advancedOutTradeno
          }), queryOrderStatusAli({
            outTradeNo: this.advancedOutTradeno
          }))
        }

        if (promises.length > 0) {
          Promise.all(promises).then(res => {
            // console.log(res)
            for (let i = 0; i < res.length; i++) {
              const { code, data } = res[i]
              if (code !== 0) {
                continue
              }
              const { type, status } = data
              if ((type === 'wechatPay' && status === 'SUCCESS') || (type === 'aliPay' && status === 'TRADE_SUCCESS')) {
                this.$emit('paySuccess')
                this.die()
                return true
              }
            }
          })
        }
      }, 2000)
    },
    // 退出
    exit () {
      this.$emit('exit')
      this.die()
    },
    die () {
      this.$destroy()
    }
  },
  created () {
    this.activeTab = this.activeTabIndex
    this.checkPay()
    // 先算价（含账户余额）再渲染支付面板，余额充足时优先选中余额支付
    this.loadPayPrice()
  },
  destroyed () {
    this.activeTab = ''
    timeOut && clearInterval(timeOut)
    timeOut = null
    // 【临时-测试用】清理模拟支付自动确认定时器
    mockTimer && clearTimeout(mockTimer)
    mockTimer = null
  }
}
</script>

<style lang="less" scoped>
.hint {
  height: 40px;
  line-height: 40px;
  color: #b94a48;
}
.pay-loading {
  min-height: 220px;
}
.coupon-label{
  display: inline-block;
  width: 100%;
  padding: 10px 8px 0 0;
  text-align: right;
}
</style>
